<template>
  <div id="app">
    <!-- 卡券商城改动：使用 keep-alive 缓存页面 -->
    <keep-alive :include="keepAliveComps">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      keepAliveComps: ['Mall', 'Bounty', 'BountyExchange'],
    };
  },
  $route(to, from) {
    // ========================================
    // 1. 卡券商城改动：处理 clearKeepAlive：清除特定页面缓存
    // ========================================
    // 场景：进入某些特殊页面（如随心配）时，需要清除其他页面的缓存
    // 例如：进入 CouponFreeCompose 页面时，清除 OrderList改名MallOrder 的缓存
    if (to.meta.clearKeepAlive) {
      this.keepAliveComps = this.keepAliveComps.filter((comp) => comp !== 'MallOrder');
      return;
    }
    // ========================================
    // 2. 卡券商城改动：添加页面到缓存列表
    // ========================================
    // 场景：当进入一个需要缓存的页面时，将其加入缓存列表
    // 条件：
    //   - to.meta.keepAlive: 目标页面配置了需要缓存
    //   - !this.keepAliveComps.includes(to.name): 该页面还未在缓存列表中
    if (to.meta.keepAlive) {
      const compName = to.meta.keepAliveName || to.name;
      if (!this.keepAliveComps.includes(compName)) {
        this.keepAliveComps.push(compName);
      }
    }
    // ========================================
    // 3. 卡券商城改动：根据页面层级清理缓存
    // ========================================
    // 场景：从深层页面返回到浅层页面时，清除深层页面的缓存
    // 条件：
    //   - from.meta.keepAlive: 来源页面配置了缓存
    //   - to.meta.deepth < from.meta.deepth: 目标页面层级更浅（返回上层）
    // 例如：从订单列表(deepth:2) 返回到首页(deepth:1)，清除订单列表缓存
    if (from.meta.keepAlive && to.meta.deepth < from.meta.deepth) {
      const compName = from.meta.keepAliveName || from.name;
      const index = this.keepAliveComps.indexOf(compName);
      if (index !== -1) {
        this.keepAliveComps.splice(index, 1);
      }
    }
  },
};
</script>

<style lang="less">
  @import './styles/index.less'; // 全局自定义的css样式
  #app {
    height: 100%;
    background: white;
    font-size: 16px;
  }
</style>
